import { createContext, useContext } from "react";

// On dark-overlay pages the chrome floats over the page's own hero media, so
// the hero decides whether white-on-media (dark) or default black text (light)
// is legible. Pages with static heroes never need to call this.
export type ChromeOverlayTone = "dark" | "light";

export const ChromeOverlayToneContext = createContext<
  (tone: ChromeOverlayTone) => void
>(() => {});

export const useSetChromeOverlayTone = () =>
  useContext(ChromeOverlayToneContext);
